import { GraphQLResult, generateClient } from 'aws-amplify/api';
import config from './config';

const client = generateClient({
  authMode: 'userPool',
});

const lambdaAuthClient = generateClient({
  authMode: 'lambda',
});

export function fetchGraphqlWithAmplify<TVariables>(query: string, variables?: TVariables) {
  return lambdaAuthClient.graphql(
    { query, variables: (variables || {} as any) },
    () => {
      const cookie = document.cookie.split('; ').filter((c) => c.startsWith(config.Auth.Cookies.CookiePrefix) || c.startsWith('current-project')).join('; ');
      return Promise.resolve({
        ...cookie && { Authorization: cookie },
      });
    },
  );
}

export function fetchCoreApi<TData, TVariables>(query: string, variables?: TVariables) {
  return async () => {
    const result = await fetchGraphqlWithAmplify(query, variables) as unknown as GraphQLResult<TData>;
    if (result.errors) {
      const message = result.errors ? result.errors[0].message : 'GraphQL fetching error';
      throw new Error(message);
    }

    return result.data!;
  };
}

export function fetchWithAmplify<TData, TVariables>(query: string, variables?: TVariables): (() => Promise<TData>) {
  return async () => {
    const result = await (client.graphql({
      query,
      variables: (variables || {} as any),
    }) as Promise<GraphQLResult<TData>>);
    if (result.errors) {
      const message = result.errors ? result.errors[0].message : 'GraphQL fetching error';
      throw new Error(message);
    }

    return result.data!;
  };
}
